import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { TextField, Box, MenuItem, Typography, Grid, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { appStyles } from '../App.styles';
/** Local styles */
const styles = {
    container: {
        width: '100%',
        padding: '0 0 1.5rem',
    },
    text: {
        width: '100%',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.03125rem',
        color: '#191C1B',
        textAlign: 'left',
        alignItems: 'left',
        borderColor: '#707973',
    },
};
;
/**
 * Customized Select
 * @param {any} props
 * @returns {<Box>}
 */
export const SelectSG = function (props) {
    const { t } = useTranslation();
    const { items, label, hidden, xstyles, disableUnderline, } = props;
    const outerStyles = xstyles || {};
    return (_jsx(Box, Object.assign({ sx: Object.assign(Object.assign(Object.assign({}, styles.container), { display: hidden ? 'none' : 'block' }), outerStyles) }, { children: _jsx(TextField
        // Customized select
        , Object.assign({ 
            // Customized select
            color: "primary" }, props, { label: t(label), select: true, sx: Object.assign(Object.assign({}, styles.text), { '& .MuiInput-input:focus': { backgroundColor: 'transparent' }, '& .MuiInputBase-root div.MuiSelect-select': {
                    backgroundColor: 'white.main',
                } }), InputProps: {
                disableUnderline: Boolean(disableUnderline),
                //disableFocus: true,
            } }, { children: items.map((item) => {
                if (typeof (item) === 'string') {
                    return (_jsx(MenuItem, Object.assign({ value: item }, { children: t(item) }), item));
                }
                else {
                    const /** Item Icon */ Icon = item === null || item === void 0 ? void 0 : item.Icon;
                    return (_jsxs(MenuItem, Object.assign({ value: item === null || item === void 0 ? void 0 : item.value, sx: {
                            display: 'block',
                        }, disabled: ((item === null || item === void 0 ? void 0 : item.isReleased) === false) ? true : false }, { children: [_jsxs(Grid, Object.assign({ container: true, sx: {
                                    width: '100%',
                                    overflow: 'hidden',
                                    flexWrap: 'nowrap',
                                    alignItems: 'center',
                                } }, { children: [Icon ? _jsx(Box, { component: Icon, sx: { margin: '0 0.25rem 0 0' } }) : null, _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'h1', sx: Object.assign({}, appStyles.text16) }, { children: t(item === null || item === void 0 ? void 0 : item.title) })) })), _jsx(Grid, Object.assign({ item: true, sx: { display: ((item === null || item === void 0 ? void 0 : item.isProModel) === true || (item === null || item === void 0 ? void 0 : item.isReleased) === false) ? 'flex' : 'none' } }, { children: _jsxs(Grid, Object.assign({ container: true, sx: { flexWrap: 'nowrap' } }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: "\u00A0" })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'text16', sx: {
                                                            fontWeight: 'bold',
                                                            color: 'blueLighter.main',
                                                        } }, { children: "\u00B7" })) })), _jsx(Grid, Object.assign({ item: true }, { children: "\u00A0" })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: 'text12', sx: {
                                                            color: 'blueLighter.main',
                                                            fontWeight: 'bold'
                                                        } }, { children: ((item === null || item === void 0 ? void 0 : item.isReleased) === false) ? t('UPCOMING') : ((item === null || item === void 0 ? void 0 : item.isProModel) === true ? (t(`PRO`)) : '') })) }))] })) }))] })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text12), { color: '#4B635A', display: 'none' }) }, { children: t(item === null || item === void 0 ? void 0 : item.subtitle) }))] }), item === null || item === void 0 ? void 0 : item.value));
                }
                ;
            }) })) })));
};
